import React, { createContext, useState } from 'react';

// Criação do contexto
const ProductContext = createContext();

export { ProductContext };

// Provedor do contexto
export default function ProductContextProvider({ children }) {
    const [products, setProducts] = useState([]);
    const [exported, setExported] = useState('Export spreadsheet');
    return (
        <ProductContext.Provider value={{ 
            products, 
            setProducts,
            exported, 
            setExported 
        }}>
            {children}
        </ProductContext.Provider>
    );
}